import { aiFirstCreationStreamingState } from '@databases/database-ai-first-creation-state';
import { useDatabaseStreamState } from '@databases/database-ai-first-creation-ui';
import { defaultStoreUtils } from '@databases/redux';
import { deselectAll } from '@databases/redux/cellSelections/actions';
import { useEffect, useRef } from 'react';
import { useSnapshot } from 'valtio';

export const useDeselectOnStreaming = (isStreaming: boolean): void => {
  const dispatch = defaultStoreUtils.useDispatch();
  const { operationType } = useDatabaseStreamState();
  const { currentFieldOperation, currentEntryOperation } = useSnapshot(
    aiFirstCreationStreamingState
  );
  const hasDeselected = useRef(false);

  useEffect(() => {
    if (!isStreaming) {
      hasDeselected.current = false;
      return;
    }

    const isDeletingField =
      operationType === 'edit' && currentFieldOperation === 'delete';
    const isDeletingEntry =
      operationType === 'edit' && currentEntryOperation === 'delete';

    if (!hasDeselected.current && !isDeletingField && !isDeletingEntry) {
      dispatch(deselectAll());
      hasDeselected.current = true;
    }
  }, [
    dispatch,
    isStreaming,
    operationType,
    currentFieldOperation,
    currentEntryOperation,
  ]);
};
